import "./Loader.css";

const Loader = () => {
  return (
    <div id="loader-wrapper">
      <div id="loader" />
      <div className="dot-container">
        <div className="dot-pulse"></div>
      </div>
    </div>
  );
};

export { Loader };
